__turbopack_context__.v({
  "app_light_theme": "PromotionCard-module-scss-module__FSeDxG__app_light_theme",
  "bottom": "PromotionCard-module-scss-module__FSeDxG__bottom",
  "date": "PromotionCard-module-scss-module__FSeDxG__date",
  "imageWrap": "PromotionCard-module-scss-module__FSeDxG__imageWrap",
  "link": "PromotionCard-module-scss-module__FSeDxG__link",
  "serviceItem": "PromotionCard-module-scss-module__FSeDxG__serviceItem",
  "text": "PromotionCard-module-scss-module__FSeDxG__text",
  "title": "PromotionCard-module-scss-module__FSeDxG__title",
});
